var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentBefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_1038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4856 31.9508L33.0176 47.4187C27.892 52.5443 19.5817 52.5443 14.4561 47.4187C9.33044 42.2931 9.33044 33.9828 14.4561 28.8572L32.5757 10.7376C35.9928 7.32046 41.533 7.32046 44.95 10.7376C48.3671 14.1546 48.3671 19.6948 44.95 23.1119L26.8304 41.2315C25.1219 42.9401 22.3518 42.9401 20.6433 41.2315C18.9347 39.523 18.9347 36.7529 20.6433 35.0443L38.7629 16.9247",
    stroke: "#727272",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_1038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentBefore);
export default __webpack_public_path__ + "static/media/Attachment-Before.e3f9d23d1b0994b648d572911f01e34c.svg";
export { ForwardRef as ReactComponent };